<div class="route-shell">
  <aside class="route-sidebar" [class.route-sidebar--collapsed]="!expanded">
    <button
      type="button"
      class="route-sidebar__hamburger"
      (click)="expanded = !expanded"
      [attr.aria-expanded]="expanded"
      [attr.title]="expanded ? 'Collapse navigation' : 'Expand navigation'"
      >
      <i class="ms-Icon ms-Icon--GlobalNavButton" aria-hidden="true"></i>
    </button>

    <button
      type="button"
      class="route-sidebar__toggle"
      (click)="expanded = !expanded"
      [attr.aria-expanded]="expanded"
      [attr.title]="expanded ? '<' : '>'"
      >
      <span class="route-sidebar__toggle-bar" aria-hidden="true"></span>
      <img
        class="route-sidebar__toggle-icon"
        [src]="expanded ? toggleCollapseIcon : toggleExpandIcon"
        alt=""
        aria-hidden="true"
        />
    </button>

    <div class="route-sidebar__sections">
      <nav class="route-sidebar__nav">
        @for (item of sidebarPrimaryNav; track item) {
          <button
            type="button"
            class="route-sidebar__item"
            [class.route-sidebar__item--active]="isSelected(item)"
            (click)="onNavSelect(item)"
            [attr.title]="item.text"
            >
            <span class="route-sidebar__icon">
              @if (item.iconSrc) {
                <img class="route-sidebar__svg-icon" [src]="item.iconSrc" alt="" aria-hidden="true" />
              }
              @if (!item.iconSrc && item.ms_icon) {
                <i class="ms-Icon" [ngClass]="item.ms_icon" aria-hidden="true"></i>
              }
              @if (item.subscription) {
                <span class="route-sidebar__badge route-sidebar__badge--pro">PRO</span>
              }
              @if (item.team) {
                <span class="route-sidebar__badge route-sidebar__badge--team">TEAMS</span>
              }
            </span>
            @if (expanded) {
              <span class="route-sidebar__label">{{ item.text }}</span>
            }
          </button>
        }
      </nav>

      <section class="route-sidebar__section">
        <button
          type="button"
          class="route-sidebar__section-header"
          (click)="sidebarDiscoverExpanded = !sidebarDiscoverExpanded"
          [attr.aria-expanded]="sidebarDiscoverExpanded"
          title="Toggle DISCOVER"
          >
          <span class="route-sidebar__icon">
            <i class="ms-Icon ms-Icon--SearchAndApps" aria-hidden="true"></i>
            <span class="route-sidebar__badge route-sidebar__badge--pro">PRO</span>
          </span>
          @if (expanded) {
            <span class="route-sidebar__section-title">DISCOVER</span>
          }
          <i class="ms-Icon ms-Icon--ChevronDown route-sidebar__group-caret" [class.route-sidebar__group-caret--open]="sidebarDiscoverExpanded" aria-hidden="true"></i>
        </button>

        @if (sidebarDiscoverExpanded) {
          <div class="route-sidebar__section-items">
            @for (item of sidebarDiscoverChildren; track item) {
              <button
                type="button"
                class="route-sidebar__item"
                [class.route-sidebar__item--active]="isSelected(item)"
                [class.route-sidebar__item--future]="item.futureLabel"
                [disabled]="item.disabled"
                (click)="onNavSelect(item)"
                [attr.title]="item.futureLabel ? item.text + ' — ' + item.futureLabel : item.text"
                >
                <span class="route-sidebar__icon">
                  @if (item.iconSrc) {
                    <img class="route-sidebar__svg-icon" [src]="item.iconSrc" alt="" aria-hidden="true" />
                  }
                  @if (!item.iconSrc && item.ms_icon) {
                    <i class="ms-Icon" [ngClass]="item.ms_icon" aria-hidden="true"></i>
                  }
                  @if (item.subscription) {
                    <span class="route-sidebar__badge route-sidebar__badge--pro">PRO</span>
                  }
                </span>
                @if (expanded) {
                  <span class="route-sidebar__label">{{ item.text }}</span>
                  @if (item.futureLabel) {
                    <span class="route-sidebar__future-label">{{ item.futureLabel }}</span>
                  }
                }
              </button>
            }
          </div>
        }
      </section>

      <section class="route-sidebar__section">
        <button
          type="button"
          class="route-sidebar__section-header"
          (click)="sidebarBuildExpanded = !sidebarBuildExpanded"
          [attr.aria-expanded]="sidebarBuildExpanded"
          title="Toggle BUILD"
          >
          <span class="route-sidebar__icon">
            <i class="ms-Icon ms-Icon--Build" aria-hidden="true"></i>
            <span class="route-sidebar__badge route-sidebar__badge--pro">PRO</span>
          </span>
          @if (expanded) {
            <span class="route-sidebar__section-title">BUILD</span>
          }
          <i class="ms-Icon ms-Icon--ChevronDown route-sidebar__group-caret" [class.route-sidebar__group-caret--open]="sidebarBuildExpanded" aria-hidden="true"></i>
        </button>

        @if (sidebarBuildExpanded) {
          <div class="route-sidebar__section-items">
            @for (item of sidebarBuildChildren; track item) {
              <button
                type="button"
                class="route-sidebar__item"
                [class.route-sidebar__item--active]="isSelected(item)"
                (click)="onNavSelect(item)"
                [attr.title]="item.text"
                >
                <span class="route-sidebar__icon">
                  @if (item.iconSrc) {
                    <img class="route-sidebar__svg-icon" [src]="item.iconSrc" alt="" aria-hidden="true" />
                  }
                  @if (!item.iconSrc && item.ms_icon) {
                    <i class="ms-Icon" [ngClass]="item.ms_icon" aria-hidden="true"></i>
                  }
                  @if (item.subscription) {
                    <span class="route-sidebar__badge route-sidebar__badge--pro">PRO</span>
                  }
                </span>
                @if (expanded) {
                  <span class="route-sidebar__label">{{ item.text }}</span>
                }
              </button>
            }
          </div>
        }
      </section>

      @if (sidebarWorkspaceNav.length) {
        <nav class="route-sidebar__nav route-sidebar__nav--workspace">
          @for (item of sidebarWorkspaceNav; track item) {
            <button
              type="button"
              class="route-sidebar__item"
              [class.route-sidebar__item--active]="isSelected(item)"
              (click)="onNavSelect(item)"
              [attr.title]="item.text"
              >
              <span class="route-sidebar__icon">
                @if (item.iconSrc) {
                  <img class="route-sidebar__svg-icon" [src]="item.iconSrc" alt="" aria-hidden="true" />
                }
                @if (!item.iconSrc && item.ms_icon) {
                  <i class="ms-Icon" [ngClass]="item.ms_icon" aria-hidden="true"></i>
                }
                @if (item.team) {
                  <span class="route-sidebar__badge route-sidebar__badge--team">TEAMS</span>
                }
              </span>
              @if (expanded) {
                <span class="route-sidebar__label">{{ item.text }}</span>
              }
            </button>
          }
        </nav>
      }

      @if (sidebarFooterNav.length) {
        <nav class="route-sidebar__footer">
          <div class="route-sidebar__separator"></div>
          @for (item of sidebarFooterNav; track item) {
            @if (!item.separator) {
              <button
                type="button"
                class="route-sidebar__item"
                [class.route-sidebar__item--active]="isSelected(item)"
                (click)="onNavSelect(item)"
                [attr.title]="item.text"
                >
                <span class="route-sidebar__icon">
                  @if (item.ms_icon) {
                    <i class="ms-Icon" [ngClass]="item.ms_icon" aria-hidden="true"></i>
                  }
                  @if (item.subscription) {
                    <span class="route-sidebar__badge route-sidebar__badge--pro">PRO</span>
                  }
                  @if (item.team) {
                    <span class="route-sidebar__badge route-sidebar__badge--team">TEAMS</span>
                  }
                </span>
                @if (expanded) {
                  <span class="route-sidebar__label">{{ item.text }}</span>
                }
              </button>
            }
          }
        </nav>
      }
    </div>
  </aside>

  <main class="route-content">
    <div class="pane-content" [class.pane-content--primary-only]="tabs.length === 0">
      <kendo-tabstrip [keepTabContent]="true" #tabStrip (tabSelect)="onTabSelect($event)" (tabClose)="onTabClose($event)">
        <kendo-tabstrip-tab [title]="this.routeName" [selected]="selectedTabIndex === 0">
          <ng-template kendoTabContent>
            <router-outlet name="primary" data-outlet-scope="route-shell"></router-outlet>
          </ng-template>
        </kendo-tabstrip-tab>
        @for (tab of tabs; track trackTab(i, tab); let i = $index) {
          <kendo-tabstrip-tab [title]="tab.title" [closable]="true" [selected]="selectedTabIndex === i + 1">
            <ng-template kendoTabContent *loadOnDemand>
              @if (tab.type == 'app-flow-detail') {
                <app-flow-detail [editorType]="tab.value" [flow]="tab.item" ></app-flow-detail>
              }
              @if (tab.type == 'app-flow-runs') {
                <app-flow-runs [flow]="tab.item" [deep]="tab.value[0]" [admin]="tab.value[1]" [more]="tab.value[2]" [status]="tab.value[3]"></app-flow-runs>
              }
              @if (tab.type == 'app-flow-diff') {
                <app-flow-diff [versionLeft]="tab.value?.[0] || null" [versionRight]="tab.value?.[1] || null"></app-flow-diff>
              }
              @if (tab.type == 'app-connector-detail') {
                <app-flow-detail [editorType]="tab.value" [connection]="tab.item" ></app-flow-detail>
              }
              @if (tab.type == 'app-connection-detail') {
                <app-flow-detail [editorType]="tab.value" [connection]="tab.item" ></app-flow-detail>
              }
              @if (tab.type == 'app-plan-edit') {
                <app-plan-edit [plans]="tab.item"></app-plan-edit>
              }
              @if (tab.type == 'app-plan') {
                <app-plan-edit [plan]="tab.item"></app-plan-edit>
              }
            </ng-template>
          </kendo-tabstrip-tab>
        }
      </kendo-tabstrip>
    </div>
  </main>
</div>
